import React, { useMemo, useState } from 'react';

import hennaFlowerBloom from '../images/hennaFlowerBloom.png';
import hennaCoupleHeart from '../images/hennaCoupleHeart.png';
import hennaBaybayinText from '../images/hennaBaybayinText.png';
import hennaCat from '../images/hennaCat.png';
import hennaHeadphone from '../images/hennaHeadphone.png';
import hennaButterfly from '../images/hennaButterfly.png';
import hennaPanda from '../images/hennaPanda.jpg';
import hennaButterfly2 from '../images/hennaButterfly2.png';
import hennaButterfly3 from '../images/hennaButterfly3.png';
import hennaCatface from '../images/hennaCatface.png';
import hennaFlowervine from '../images/hennaFlowervine.png';


const hennaPackages = [
  {
    id: 'flowers-bliss',
    name: 'Flower Bloom Henna',
    price: 50,
    duration: '20 minutes',
    image: hennaFlowerBloom,
    description: 'Flower 50 pesos per couple, 20 pesos per additional design. Hand-drawn floral patterns for a timeless look.',
  },
  {
    id: 'valentines-heart',
    name: 'Couple Heart Henna',
    price: 30,
    duration: '30 minutes',
    image: hennaCoupleHeart,
    description: 'Aesthetic couple heart henna tattoo.',
  },
  {
    id: 'baybayin',
    name: 'Baybayin text Henna',
    price: 30,
    duration: '20 minutes',
    image: hennaBaybayinText,
    description: 'Hand written baybayin text henna tattoo.',
  },
  {
    id: 'animal-cat',
    name: 'Henna Cat',
    price: 30,
    duration: '5 minutes',
    image: hennaCat,
    description: 'Henna cat with foot steps.',
  },
  {
    id: 'music',
    name: 'Henna Headphone',
    price: 30,
    duration: '20 minutes',
    image: hennaHeadphone,
    description: 'Cute henna headphone design.',
  },
  {
    id: 'insect-b1',
    name: 'Butterfly Henna',
    price: 30,
    duration: '25 minutes',
    image: hennaButterfly,
    description: 'Delicate butterfly pattern for a subtle look.',
  },
  {
    id: 'insect-b2',
    name: 'Butterfly 2 Henna',
    price: 30,
    duration: '40 minutes',
    image: hennaButterfly2,
    description: 'Intricate butterfly blend suited for events and parties.',
  },
  {
    id: 'insect-b3',
    name: 'Butterfly 3 Henna',
    price: 30,
    duration: '30 minutes',
    image: hennaButterfly3,
    description: 'Custom butterfly design with decorative details.',
  },
  {
    id: 'animal-catface',
    name: 'Cat Face Henna',
    price: 30,
    duration: '35 minutes',
    image: hennaCatface,
    description: 'Adorable cat face design with sunrise motifs.',
  },
  {
    id: 'animal-panda',
    name: 'Panda Henna',
    price: 30,
    duration: '40 minutes',
    image: hennaPanda,
    description: 'Cute panda design for couples and friends.',
  },
  {
    id: 'flower-vine',
    name: 'Flower Vine Henna',
    price: 30,
    duration: '30 minutes',
    image: hennaFlowervine,
    description: 'Baybayin phrase with ornamental framing.',
  },
];

const studioLocation = {
  venue: 'eBaybayMo Creative Studio',
  address: 'Inside Multimedia room, Ctech office, BISU Bilar Campus',
};

const styles = {
  page: {
    minHeight: '100vh',
    padding: '2.8rem 1.5rem 4rem',
    background: '#f3f4f6',
    fontFamily: '"Poppins", "Segoe UI", sans-serif',
    color: '#2c2f35',
  },
  shell: {
    maxWidth: '10000px',
    margin: '0 auto',
  },
  hero: {
    textAlign: 'center',
    marginBottom: '1.3rem',
  },
  heroTitle: {
    fontSize: 'clamp(2rem, 4vw, 3.1rem)',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    marginBottom: '0.7rem',
    color: '#1f2937',
  },
  heroSubtitle: {
    fontSize: '1.02rem',
    maxWidth: '700px',
    margin: '0 auto',
    lineHeight: 1.6,
    color: '#4b5563',
  },
  topDetails: {
    background: '#ffffff',
    borderRadius: '16px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 8px 20px rgba(15, 23, 42, 0.05)',
    padding: '1.25rem 1.3rem',
    marginBottom: '1.2rem',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1rem',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  topDetailsInfo: {
    flex: '1 1 420px',
  },
  topDetailsActions: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
  },
  gallery: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
    gap: '1rem',
    marginBottom: 0,
    alignContent: 'start',
  },
  gallerySection: {
    background: '#ffffff',
    borderRadius: '16px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 8px 20px rgba(15, 23, 42, 0.05)',
    padding: '1rem',
    marginBottom: '3rem',
  },
  card: {
    background: '#ffffff',
    borderRadius: '20px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 6px 16px rgba(15, 23, 42, 0.06)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  cardImage: {
    width: '100%',
    height: '190px',
    objectFit: 'cover',
  },
  cardBody: {
    padding: '0.95rem 1rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.3rem',
  },
  cardPrice: {
    fontWeight: 700,
    fontSize: '1rem',
    color: '#0b63c9',
  },
  bookingGrid: {
    display: 'grid',
    gap: '1.1rem',
    gridTemplateColumns: 'minmax(280px, 780px)',
    justifyContent: 'center',
  },
  bookingCard: {
    background: '#ffffff',
    borderRadius: '20px',
    border: '1px solid #e5e7eb',
    padding: '2rem 1.75rem',
    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.07)',
  },
  label: {
    fontSize: '0.85rem',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontWeight: 600,
    color: '#6b4f38',
    marginBottom: '0.35rem',
    display: 'block',
  },
  input: {
    width: '100%',
    borderRadius: '12px',
    border: '1px solid #e8bea2',
    padding: '0.75rem 1rem',
    fontSize: '1rem',
    marginBottom: '1rem',
    background: '#fffcfa',
    outline: 'none',
  },
  select: {
    width: '100%',
    borderRadius: '12px',
    border: '1px solid #e8bea2',
    padding: '0.75rem 1rem',
    fontSize: '1rem',
    marginBottom: '1rem',
    background: '#fffcfa',
    outline: 'none',
  },
  button: {
    width: '100%',
    border: 'none',
    borderRadius: '999px',
    padding: '1rem 1.5rem',
    background: 'linear-gradient(120deg, #0f6dcf, #0a56a3)',
    color: '#fff',
    fontWeight: 700,
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'opacity 0.2s ease, transform 0.2s ease',
  },
  quickActionButton: {
    border: 'none',
    borderRadius: '999px',
    padding: '0.8rem 1.2rem',
    background: 'linear-gradient(120deg, #0f6dcf, #0a56a3)',
    color: '#fff',
    fontWeight: 700,
    fontSize: '0.95rem',
    cursor: 'pointer',
    minWidth: '180px',
  },
  secondaryActionButton: {
    border: '1px solid #cbd5e1',
    borderRadius: '999px',
    padding: '0.8rem 1.2rem',
    background: '#ffffff',
    color: '#1f2937',
    fontWeight: 700,
    fontSize: '0.95rem',
    cursor: 'pointer',
    minWidth: '180px',
  },
  schedule: {
    background: 'transparent',
    borderRadius: 0,
    border: 'none',
    padding: 0,
    boxShadow: 'none',
    alignSelf: 'start',
  },
  confirmation: {
    marginTop: '2rem',
    padding: '1.35rem 1.5rem',
    borderRadius: '18px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.07)',
  },
  pageContent: {
    transition: 'filter 0.2s ease',
  },
  pageContentBlurred: {
    filter: 'blur(3px)',
  },
  modalOverlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(17, 24, 39, 0.25)',
    backdropFilter: 'blur(2px)',
    WebkitBackdropFilter: 'blur(2px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    zIndex: 1200,
  },
  modalCard: {
    width: 'min(720px, 100%)',
    maxHeight: '90vh',
    overflowY: 'auto',
    background: '#ffffff',
    borderRadius: '16px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 20px 50px rgba(15, 23, 42, 0.25)',
    padding: '3rem',
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '0.8rem',
    gap: '0.8rem',
  },
  closeButton: {
    border: '1px solid #d1d5db',
    background: '#ffffff',
    color: '#111827',
    borderRadius: '10px',
    padding: '0.45rem 0.8rem',
    cursor: 'pointer',
    fontWeight: 600,
  },
  appointmentListWrap: {
    marginTop: '0.6rem',
    display: 'grid',
    gap: '0.7rem',
  },
  appointmentItem: {
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    padding: '0.75rem 0.9rem',
    background: '#f8fafc',
  },
  appointmentRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0.7rem',
    flexWrap: 'wrap',
  },
  statusPillPending: {
    padding: '0.2rem 0.55rem',
    borderRadius: '999px',
    background: '#fef3c7',
    color: '#92400e',
    fontWeight: 700,
    fontSize: '0.78rem',
    textTransform: 'capitalize',
  },
  statusPillAccepted: {
    padding: '0.2rem 0.55rem',
    borderRadius: '999px',
    background: '#dcfce7',
    color: '#166534',
    fontWeight: 700,
    fontSize: '0.78rem',
    textTransform: 'capitalize',
  },
  mutedText: {
    color: '#64748b',
    margin: 0,
  },
  successOverlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(17, 24, 39, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    zIndex: 1300,
  },
  successCard: {
    width: 'min(430px, 100%)',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '14px',
    boxShadow: '0 16px 40px rgba(15, 23, 42, 0.18)',
    padding: '1.25rem 1.2rem',
    textAlign: 'center',
  },
};

const HennaBooking = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    packageId: hennaPackages[0].id,
    date: '',
    time: '',
    notes: '',
  });
  const [formError, setFormError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [showAppointmentsModal, setShowAppointmentsModal] = useState(false);
  const [userAppointments, setUserAppointments] = useState([]);
  const [appointmentsLoading, setAppointmentsLoading] = useState(false);
  const [appointmentsError, setAppointmentsError] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const selectedPackage = useMemo(
    () => hennaPackages.find((pkg) => pkg.id === formData.packageId),
    [formData.packageId],
  );

  const resolveLoggedInUserId = () => {
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) return Number(storedUserId);

    try {
      const loginDataRaw = localStorage.getItem('loginData');
      if (loginDataRaw) {
        const loginData = JSON.parse(loginDataRaw);
        if (loginData?.id) return Number(loginData.id);
      }
    } catch (error) {
      // Ignore malformed loginData and continue with other sources.
    }

    const sessionId = localStorage.getItem('sessionId');
    if (sessionId) return Number(sessionId);
    return null;
  };

  const loadAppointmentsFromLocal = (userId) => {
    try {
      const raw = localStorage.getItem('hennaAppointments');
      const parsed = raw ? JSON.parse(raw) : [];
      return parsed.filter((item) => Number(item.user_id) === Number(userId));
    } catch (error) {
      return [];
    }
  };

  const normalizeStatus = (status) => {
    const normalized = String(status || 'pending').toLowerCase();
    if (['accepted', 'approved', 'confirmed'].includes(normalized)) {
      return 'accepted';
    }
    return 'pending';
  };

  const loadUserAppointments = async () => {
    const userId = resolveLoggedInUserId();
    if (!userId) {
      setAppointmentsError('Please log in to view your appointments.');
      setUserAppointments([]);
      return;
    }

    setAppointmentsLoading(true);
    setAppointmentsError('');

    const baseUrl = 'https://ebaybaymo-server-b084d082cda7.herokuapp.com/';

    try {
      const response = await fetch(`${baseUrl}henna/bookings?user_id=${userId}`);
      if (!response.ok) {
        throw new Error('Henna appointments endpoint is not available.');
      }

      const payload = await response.json();
      const rows = Array.isArray(payload) ? payload : payload?.data || [];
      const normalizedRows = rows.map((item) => ({
        ...item,
        status: normalizeStatus(item.status || item.booking_status),
      }));
      setUserAppointments(normalizedRows);
    } catch (error) {
      const localRows = loadAppointmentsFromLocal(userId).map((item) => ({
        ...item,
        status: normalizeStatus(item.status),
      }));
      setUserAppointments(localRows);
    } finally {
      setAppointmentsLoading(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const userId = resolveLoggedInUserId();

    if (!userId) {
      setFormError('Please log in first before creating an appointment.');
      return;
    }

    if (!formData.date || !formData.time || !formData.fullName) {
      setFormError('Please complete your name, date, and time to confirm the booking.');
      return;
    }

    setIsSubmitting(true);
    setFormError('');

    window.setTimeout(async () => {
      const apiBaseUrl = 'https://ebaybaymo-server-b084d082cda7.herokuapp.com/';

      try {
        await fetch(`${apiBaseUrl}henna/bookings`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: userId,
            full_name: formData.fullName,
            email: formData.email,
            package_code: selectedPackage?.id || formData.packageId,
            appointment_date: formData.date,
            appointment_time: formData.time,
            notes: formData.notes,
          }),
        });
      } catch (error) {
        // Keep local storage fallback when API is unavailable.
      }

      const newAppointment = {
        appointment_id: `HENNA-${Math.random().toString(36).substring(2, 8).toUpperCase()}`,
        user_id: userId,
        full_name: formData.fullName,
        email: formData.email,
        package_name: selectedPackage?.name || 'Henna Package',
        package_code: selectedPackage?.id || formData.packageId,
        appointment_date: formData.date,
        appointment_time: formData.time,
        notes: formData.notes,
        status: 'pending',
        created_at: new Date().toISOString(),
      };

      const previousLocalAppointments = loadAppointmentsFromLocal(userId);
      try {
        const allRaw = localStorage.getItem('hennaAppointments');
        const allParsed = allRaw ? JSON.parse(allRaw) : [];
        localStorage.setItem('hennaAppointments', JSON.stringify([newAppointment, ...allParsed]));
      } catch (error) {
        localStorage.setItem('hennaAppointments', JSON.stringify([newAppointment, ...previousLocalAppointments]));
      }

      setIsSubmitting(false);
      setShowBookingForm(false);
      setShowSuccessPopup(true);
      setFormData({
        fullName: '',
        email: '',
        packageId: hennaPackages[0].id,
        date: '',
        time: '',
        notes: '',
      });

      window.setTimeout(() => {
        setShowSuccessPopup(false);
      }, 1600);
    }, 800);
  };

  return (
    <div style={styles.page}>
      <div
        style={{
          ...styles.pageContent,
          ...(showBookingForm || showSuccessPopup || showAppointmentsModal ? styles.pageContentBlurred : {}),
        }}
      >
        <div style={styles.shell}>
        <header style={styles.hero}>
          <p
            style={{
              textTransform: 'uppercase',
              letterSpacing: '0.25em',
              color: '#a14f31',
              fontWeight: 600,
              marginBottom: '0.7rem',
            }}
          >
            curated henna experiences
          </p>
          <h1 style={styles.heroTitle}>Reserve Your Henna Session</h1>
          <p style={styles.heroSubtitle}>
            Choose from hand-drawn designs crafted for weddings, shoots, and everyday celebrations. Secure your
            preferred schedule and receive an on-screen confirmation instantly.
          </p>
        </header>

        <section style={styles.topDetails}>
          <div style={{ ...styles.schedule, ...styles.topDetailsInfo }}>
            <h2 style={{ marginTop: 0 }}>Studio details</h2>
            <p style={{ marginBottom: '1rem', lineHeight: 1.5 }}>
              {studioLocation.venue}
              <br />
              {studioLocation.address}
            </p>
            <ul style={{ paddingLeft: '1.2rem', lineHeight: 1.5 }}>
              <li>Studio hours: 11:00 AM - 12:00 PM (Wed-Fri)</li>
              <li>Walk-ins welcome when slots are free</li>
              <li>Reserved clients are prioritized</li>
            </ul>
            <div style={{ marginTop: '1rem', padding: '0.85rem 1rem', borderRadius: '12px', background: '#f9fafb' }}>
              <strong>Need help?</strong>
              <p style={{ margin: '0.5rem 0 0' }}>Message us on Messenger @eBaybayMo or text 0917-555-HENN.</p>
            </div>
          </div>

          <div style={styles.topDetailsActions}>
            <button
              type="button"
              style={styles.secondaryActionButton}
              onClick={() => {
                setShowAppointmentsModal(true);
                loadUserAppointments();
              }}
            >
              My Appointments
            </button>
            <button
              type="button"
              style={{ ...styles.quickActionButton, marginLeft: '0.6rem' }}
              onClick={() => setShowBookingForm((prev) => !prev)}
            >
              {showBookingForm ? 'Hide Appointment Form' : 'Set Appointment'}
            </button>
          </div>
        </section>

        <section style={styles.gallerySection}>
          <div style={styles.gallery}>
            {hennaPackages.map((pkg, index) => (
              <article style={styles.card} key={pkg.id}>
                <img
                  src={pkg.image}
                  alt={pkg.name}
                  style={styles.cardImage}
                  loading={index < 2 ? 'eager' : 'lazy'}
                  decoding="async"
                  fetchPriority={index < 2 ? 'high' : 'low'}
                  onError={(event) => {
                    event.currentTarget.src = hennaFlowerBloom;
                  }}
                />
                <div style={styles.cardBody}>
                  <h3 style={{ fontSize: '1.23rem', margin: 0, lineHeight: 1.2 }}>{pkg.name}</h3>
                  <span style={styles.cardPrice}>PHP {pkg.price.toLocaleString()}</span>
                  <span style={{ fontSize: '0.85rem', color: '#7a5a44', fontWeight: 500 }}>{pkg.duration}</span>
                  <p style={{ margin: '0.35rem 0 0', fontSize: '0.92rem', lineHeight: 1.35, color: '#5d4333' }}>
                    {pkg.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </section>

        </div>
      </div>

      {showBookingForm && (
        <div style={styles.modalOverlay} onClick={() => setShowBookingForm(false)}>
          <div style={styles.modalCard} onClick={(event) => event.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h2 style={{ margin: 0 }}>Set your appointment</h2>
              <button type="button" style={styles.closeButton} onClick={() => setShowBookingForm(false)}>
                Close
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              {formError && (
                <p style={{ margin: '0 0 0.9rem', color: '#c0392b', fontWeight: 600 }}>{formError}</p>
              )}

              <label style={styles.label} htmlFor="fullName">
                Full name
              </label>
              <input
                style={styles.input}
                id="fullName"
                name="fullName"
                type="text"
                placeholder="Your complete name"
                value={formData.fullName}
                onChange={handleChange}
              />

              <label style={styles.label} htmlFor="email">
                Email address
              </label>
              <input
                style={styles.input}
                id="email"
                name="email"
                type="email"
                placeholder="you@example.com"
                value={formData.email}
                onChange={handleChange}
              />

              <label style={styles.label} htmlFor="packageId">
                Choose design package
              </label>
              <select
                style={styles.select}
                id="packageId"
                name="packageId"
                value={formData.packageId}
                onChange={handleChange}
              >
                {hennaPackages.map((pkg) => (
                  <option key={pkg.id} value={pkg.id}>
                    {pkg.name} - PHP {pkg.price.toLocaleString()}
                  </option>
                ))}
              </select>

              <label style={styles.label} htmlFor="date">
                Preferred date
              </label>
              <input
                style={styles.input}
                id="date"
                name="date"
                type="date"
                value={formData.date}
                onChange={handleChange}
              />

              <label style={styles.label} htmlFor="time">
                Preferred time
              </label>
              <input
                style={styles.input}
                id="time"
                name="time"
                type="time"
                value={formData.time}
                onChange={handleChange}
              />

              <label style={styles.label} htmlFor="notes">
                Special notes
              </label>
              <textarea
                style={{ ...styles.input, resize: 'vertical', minHeight: '90px' }}
                id="notes"
                name="notes"
                placeholder="Tell us about color preferences, party themes, etc."
                value={formData.notes}
                onChange={handleChange}
              />

              <button type="submit" style={styles.button} disabled={isSubmitting}>
                {isSubmitting ? 'Confirming...' : 'Book my henna session'}
              </button>
            </form>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div style={styles.successOverlay}>
          <div style={styles.successCard}>
            <h3 style={{ margin: '0 0 0.45rem', color: '#14532d' }}>Successfully Created</h3>
            <p style={{ margin: 0, color: '#374151' }}>Successfully created an appointment.</p>
          </div>
        </div>
      )}

      {showAppointmentsModal && (
        <div style={styles.modalOverlay} onClick={() => setShowAppointmentsModal(false)}>
          <div style={styles.modalCard} onClick={(event) => event.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h2 style={{ margin: 0 }}>My Appointments</h2>
              <button type="button" style={styles.closeButton} onClick={() => setShowAppointmentsModal(false)}>
                Close
              </button>
            </div>

            {appointmentsLoading ? (
              <p style={styles.mutedText}>Loading appointments...</p>
            ) : appointmentsError ? (
              <p style={{ margin: 0, color: '#b91c1c', fontWeight: 600 }}>{appointmentsError}</p>
            ) : userAppointments.length === 0 ? (
              <p style={styles.mutedText}>No appointments yet for this account.</p>
            ) : (
              <div style={styles.appointmentListWrap}>
                {userAppointments.map((item, index) => {
                  const status = normalizeStatus(item.status || item.booking_status);
                  return (
                    <div
                      key={item.appointment_id || item.reference || `${item.appointment_date}-${item.appointment_time}-${index}`}
                      style={styles.appointmentItem}
                    >
                      <div style={styles.appointmentRow}>
                        <strong>{item.package_name || item.package_code || 'Henna Package'}</strong>
                        <span style={status === 'accepted' ? styles.statusPillAccepted : styles.statusPillPending}>
                          {status}
                        </span>
                      </div>
                      <p style={{ margin: '0.4rem 0 0', color: '#475569', fontSize: '0.9rem' }}>
                        Appointment ID: {item.appointment_id || item.reference || 'Pending assignment'}
                      </p>
                      <p style={{ margin: '0.45rem 0 0', color: '#334155' }}>
                        {item.appointment_date} at {item.appointment_time}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default HennaBooking;
